<section class="b5containeradjust pt-4 pt-md-5 pb-4 pb-md-5">
    <div class="container">

        <div class="col-12 col-md-6 px-3 text-center text-md-start">
            <h2 class="mainHeading">Your Insurance Summary</h2>
            <div class="divider_yellow"></div>
            <div class="summary_width">As a DebtBusters client, your insurance premium forms part of your regular
                monthly payments.</div>
        </div>
    </div>
</section>

<section class="b5containeradjust pt-4 pt-md-5 pb-md-5 pb-4 bg-grey " *ngIf="UserPolicyDetails?.isDataAvailable">
    <div class="container">
        <div class="d-flex">
            <div class="col-12 col-lg-12 col-md-12 px-3">
                <h2 class="text-center text-md-start mainHeading">Your Policies</h2>
                <div class="divider_yellow"></div>


                <a *ngIf="UserPolicyDetails?.creditLifePolicyResponse != null"
                    class="policy d-flex justify-content-between align-items-center text-white cursor-pointer"
                    href="/portal/insurance/credit-life-cover" id="btn_userJourney_creditLifePolicy_insuranceSummary"
                    name="btn_userJourney_creditLifePolicy_insuranceSummary">

                    <div class="col-6 d-flex justify-content-between align-items-center pe-3">
                        <div class="heading">Credit Life Cover</div>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="2" height="38" viewBox="0 0 2 38"
                                fill="none">
                                <path d="M0.75 0.5V37.5" stroke="#D3D3D3" />
                            </svg>
                        </span>
                    </div>
                    <div class="col-6 d-flex justify-content-between align-items-center">
                        <div class="d-flex flex-column">
                            <div class="subHeadOne">Policy Status:</div>
                            <div class="subHeadTwo">Active</div>
                        </div>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M4.64645 1.64645C4.84171 1.45118 5.15829 1.45118 5.35355 1.64645L11.3536 7.64645C11.5488 7.84171 11.5488 8.15829 11.3536 8.35355L5.35355 14.3536C5.15829 14.5488 4.84171 14.5488 4.64645 14.3536C4.45118 14.1583 4.45118 13.8417 4.64645 13.6464L10.2929 8L4.64645 2.35355C4.45118 2.15829 4.45118 1.84171 4.64645 1.64645Z"
                                    fill="white" />
                            </svg>
                        </span>
                    </div>
                </a>

                <a *ngIf="UserPolicyDetails?.lifeCoverPolicyResponse != null" href="/portal/insurance/life-cover"
                    id="btn_userJourney_lifePolicy_insuranceSummary" name="btn_userJourney_lifePolicy_insuranceSummary"
                    class="policy d-flex justify-content-between align-items-center text-white cursor-pointer">

                    <div class="col-6 d-flex justify-content-between align-items-center pe-3">
                        <div class="heading">Life Cover</div>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="2" height="38" viewBox="0 0 2 38"
                                fill="none">
                                <path d="M0.75 0.5V37.5" stroke="#D3D3D3" />
                            </svg>
                        </span>
                    </div>
                    <div class="col-6 d-flex justify-content-between align-items-center">
                        <div class="d-flex flex-column">
                            <div class="subHeadOne">Policy Status:</div>
                            <div class="subHeadTwo">Active</div>
                        </div>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M4.64645 1.64645C4.84171 1.45118 5.15829 1.45118 5.35355 1.64645L11.3536 7.64645C11.5488 7.84171 11.5488 8.15829 11.3536 8.35355L5.35355 14.3536C5.15829 14.5488 4.84171 14.5488 4.64645 14.3536C4.45118 14.1583 4.45118 13.8417 4.64645 13.6464L10.2929 8L4.64645 2.35355C4.45118 2.15829 4.45118 1.84171 4.64645 1.64645Z"
                                    fill="white" />
                            </svg>
                        </span>
                    </div>
                </a>
                <a *ngIf="UserPolicyDetails?.legalCoverPolicyResponse != null" href="/portal/insurance/legal-cover"
                    id="btn_userJourney_legalPolicy_insuranceSummary"
                    name="btn_userJourney_legalPolicy_insuranceSummary"
                    class="policy d-flex justify-content-between align-items-center text-white cursor-pointer">

                    <div class="col-6 d-flex justify-content-between align-items-center pe-3">
                        <div class="heading">Legal Insurance Cover</div>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="2" height="38" viewBox="0 0 2 38"
                                fill="none">
                                <path d="M0.75 0.5V37.5" stroke="#D3D3D3" />
                            </svg>
                        </span>
                    </div>
                    <div class="col-6 d-flex justify-content-between align-items-center">
                        <div class="d-flex flex-column">
                            <div class="subHeadOne">Policy Status:</div>
                            <div class="subHeadTwo">Active</div>
                        </div>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M4.64645 1.64645C4.84171 1.45118 5.15829 1.45118 5.35355 1.64645L11.3536 7.64645C11.5488 7.84171 11.5488 8.15829 11.3536 8.35355L5.35355 14.3536C5.15829 14.5488 4.84171 14.5488 4.64645 14.3536C4.45118 14.1583 4.45118 13.8417 4.64645 13.6464L10.2929 8L4.64645 2.35355C4.45118 2.15829 4.45118 1.84171 4.64645 1.64645Z"
                                    fill="white" />
                            </svg>
                        </span>
                    </div>

                </a>
                <a href="/portal/insurance/funeral-cover" *ngIf="UserPolicyDetails?.funeralCoverPolicyResponse !=null"
                    class="policy d-flex justify-content-between align-items-center text-white cursor-pointer">

                    <div class="col-6 d-flex justify-content-between align-items-center pe-3">
                        <div class="heading">Funeral Cover</div>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="2" height="38" viewBox="0 0 2 38"
                                fill="none">
                                <path d="M0.75 0.5V37.5" stroke="#D3D3D3" />
                            </svg>
                        </span>
                    </div>
                    <div class="col-6 d-flex justify-content-between align-items-center">
                        <div class="d-flex flex-column">
                            <div class="subHeadOne">Policy Status:</div>
                            <div class="subHeadTwo">Active</div>
                        </div>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M4.64645 1.64645C4.84171 1.45118 5.15829 1.45118 5.35355 1.64645L11.3536 7.64645C11.5488 7.84171 11.5488 8.15829 11.3536 8.35355L5.35355 14.3536C5.15829 14.5488 4.84171 14.5488 4.64645 14.3536C4.45118 14.1583 4.45118 13.8417 4.64645 13.6464L10.2929 8L4.64645 2.35355C4.45118 2.15829 4.45118 1.84171 4.64645 1.64645Z"
                                    fill="white" />
                            </svg>
                        </span>
                    </div>
                </a>


            </div>
        </div>
    </div>
</section>

<section class="b5containeradjust pt-4 pt-md-5 pb-md-5 pb-4 " *ngIf="UserPolicyDetails!=null && isAvailablePolicy">
    <div class="container">
        <div class="d-flex">
            <div class="col-12 col-lg-12 col-md-12 px-3">
                <h2 class="text-center text-md-start mainHeading">Available Cover</h2>
                <div class="divider_yellow"></div>
                <div ngbAccordion [closeOthers]="false">
                    <div *ngIf="UserPolicyDetails?.creditLifePolicyResponse == null" ngbAccordionItem
                        id="accordion_auxilaryButton_availableCoverCreditLife_insuranceSummary"
                        [attr.name]="'accordion_auxilaryButton_availableCoverCreditLife_insuranceSummary'">
                        <h2 ngbAccordionHeader>
                            <button ngbAccordionButton>
                                <div class="d-flex align-items-center w-100">
                                    <h4 class="title w-50 font-weight-bold mb-0 ">
                                        Credit Life Cover
                                    </h4>
                                </div>
                            </button>
                        </h2>
                
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                                <div class="d-flex flex-column">
                                    <div>
                                        Credit life cover is insurance that covers your debt. If you lose your income, this solution
                                        will help you meet your financial obligations to your credit providers.
                                    </div>
                                    <div class="align-self-md-end mt-3">
                                        <button class="callMeBtn"
                                            id="accordion_auxilaryButton_availableCoverCreditLife_insuranceSummary"
                                            name="accordion_auxilaryButton_availableCoverCreditLife_insuranceSummary"
                                            (click)="CallBackLms('accordion_auxilaryButton_availableCoverCreditLife_insuranceSummary')">
                                            Call me
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <div *ngIf="UserPolicyDetails?.lifeCoverPolicyResponse == null" ngbAccordionItem
                        id="accordion_auxilaryButton_availableCoverLife_insuranceSummary"
                        [attr.name]="'accordion_auxilaryButton_availableCoverLife_insuranceSummary'">
                        <h2 ngbAccordionHeader>
                            <button ngbAccordionButton>
                                <div class="d-flex align-items-center w-100">
                                    <h4 class="title w-50 font-weight-bold mb-0 ">
                                        Life Cover
                                    </h4>
                                </div>
                            </button>
                        </h2>
                
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                                <div class="d-flex flex-column">
                                    <div>
                                        Life cover helps protect your family’s financial future in the event of your death, disability,
                                        or illness due to a dread disease. If you can no longer generate an income, it can cover living
                                        expenses and debt, such as bond repayments, for you and your family.
                                    </div>
                                    <div class="align-self-md-end mt-3">
                                        <button class="callMeBtn" id="accordion_auxilaryButton_availableCoverLife_insuranceSummary"
                                            name="accordion_auxilaryButton_availableCoverLife_insuranceSummary"
                                            (click)="CallBackLms('accordion_auxilaryButton_availableCoverLife_insuranceSummary')">
                                            Call me
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <div *ngIf="UserPolicyDetails?.funeralCoverPolicyResponse == null" ngbAccordionItem
                        id="accordion_auxilaryButton_availableCoverFuneral_insuranceSummary"
                        [attr.name]="'accordion_auxilaryButton_availableCoverFuneral_insuranceSummary'">
                        <h2 ngbAccordionHeader>
                            <button ngbAccordionButton>
                                <div class="d-flex align-items-center w-100">
                                    <h4 class="title w-50 font-weight-bold mb-0 ">
                                        Funeral Cover
                                    </h4>
                                </div>
                            </button>
                        </h2>
                
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                                <div class="d-flex flex-column">
                                    <div>
                                        Funeral cover helps your family to pay for the costs of your funeral. It also allows you to
                                        consolidate your family’s funeral policies, which can improve your financial health by saving
                                        you money and guaranteeing better protection for your family.
                                    </div>
                                    <div class="align-self-md-end mt-3">
                                        <button class="callMeBtn" id="accordion_auxilaryButton_availableCoverFuneral_insuranceSummary"
                                            name="accordion_auxilaryButton_availableCoverFuneral_insuranceSummary"
                                            (click)="CallBackLms('accordion_auxilaryButton_availableCoverFuneral_insuranceSummary')">
                                            Call me
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                    <div *ngIf="UserPolicyDetails?.legalCoverPolicyResponse == null" ngbAccordionItem
                        id="accordion_auxilaryButton_availableCoverLegal_insuranceSummary"
                        [attr.name]="'accordion_auxilaryButton_availableCoverLegal_insuranceSummary'">
                        <h2 ngbAccordionHeader>
                            <button ngbAccordionButton>
                                <div class="d-flex align-items-center w-100">
                                    <h4 class="title w-50 font-weight-bold mb-0 ">
                                        Legal Insurance Cover
                                    </h4>
                                </div>
                            </button>
                        </h2>
                
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                                <div class="d-flex flex-column">
                                    <div>
                                        Legal insurance covers any costs associated with legal proceedings. This helps you manage the
                                        financial burden of legal fees, court costs, and related expenses arising from legal issues,
                                        including contractual disputes, consumer complaints, employment issues, or personal injury
                                        claims.
                                    </div>
                                    <div class="align-self-md-end mt-3">
                                        <button class="callMeBtn" id="accordion_auxilaryButton_availableCoverLegal_insuranceSummary"
                                            name="accordion_auxilaryButton_availableCoverLegal_insuranceSummary"
                                            (click)="CallBackLms('accordion_auxilaryButton_availableCoverLegal_insuranceSummary')">
                                            Call me
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>

<section class="b5containeradjust pt-4 pt-md-5 pb-md-5 pb-4 bg-grey ">
    <div class="container">
        <div class="d-flex flex-column flex-md-row">
            <div class="col-12 col-lg-6 col-md-6 ps-md-3 px-3 px-md-0">
                <h2 class="text-center text-md-start mainHeading">Got a question about your cover?</h2>
                <div class="divider_yellow"></div>
                <div class="text-center text-md-start mb-4 mb-md-0 quesSub">We’ve made it easy for you to reach us</div>
            </div>
            <div class="col-12 col-lg-6 col-md-6 pe-md-3 px-3 px-md-0">
                <div class="questionCover_box">
                    <div class="headSummary">Have a policy-related query?</div>
                    <div>Email us at <a href="mailto:enquiries@justmoney.co.za"
                            class="foofontstyle">enquiries&#64;justmoneyprotect.co.za</a></div>
                </div>
                <div class="questionCover_box">
                    <div class="headSummary">Have a claims-related query?</div>
                    <div>Email us at <a href="mailto:lifeclaims@justmoney.co.za"
                            class="foofontstyle">lifeclaims&#64;justmoneyprotect.co.za</a></div>
                </div>
                <div class="questionCover_box">
                    <div class="headSummary">Prefer to chat on the phone?</div>
                    <div>Give us a call on <a id="expertContactNumberLink" href="tel:0860994096"
                            class="foofontstyle">086 099 4096</a></div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="b5containeradjust pt-3 pb-3" *ngIf="UserPolicyDetails?.insuranceProvider !== 'Centriq'">
    <div class="container d-flex flex-column flex-md-row justify-content-center align-items-center">
        <div class="textProvider">Policies underwritten by</div>
        <img class="providerImgHollard ms-md-2 mt-2 mt-md-0" src="../../../assets/images/hollard.png" />
    </div>
</section>

<section class="b5containeradjust pt-3 pb-3" *ngIf="UserPolicyDetails?.insuranceProvider === 'Centriq'">
    <div class="container d-flex flex-column flex-md-row justify-content-center align-items-center">
        <div class="textProvider">Policies underwritten by</div>
        <img class="providerImgCentriq ms-md-2 mt-2 mt-md-0" src="../../../assets/images/centriq.png" />
    </div>
</section>
<section class="disclaimer">
    <div>Just Money Protect (Pty) Ltd (“JustMoney Protect”) is a licensed Financial Services Provider – FSP No. 32984.
    </div>
</section>
<ng-template #callbackSuccessModel let-modal>
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">Free call-back incoming</h4>
            <button type="button" id="btn_auxiliaryButton_insuranceHub_callBackRequested_popUp_close" class="close"
                data-dismiss="modal" name="callbackSuccessModelClosed" isCloseButton="true" aria-label="Close"
                (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" role="alert">
            <p class="mb-0">An agent will contact you shortly</p>
        </div>
        <div class="modal-footer">
            <button id="btn_auxiliaryButton_consolidateLoan_callBack_popUp_no_creditReport"
                name="btn_auxiliaryButton_consolidateLoan_callBack_popUp_no_creditReport" type="button"
                class="popup-btn" (click)="modal.dismiss('Cross click')">OK, thanks!</button>
        </div>
    </div>
</ng-template>